import axios from "axios";
var md5 = require('md5');
import config from "config/index";
let host = config.host+"/api/"
let apikey=config.apikey
// initializing the axios instance with custom configs
const completeRegistration = function (name) {
    let token = localStorage.getItem("token")
    return axios.post(host + `Authentication/CompleteRegistration`,
        {
            "name":name
        },
        {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
                "ApiKey": apikey
            }
        }).then((response) => {
            return response.data
        })
}


export default completeRegistration